const convertToPoints = (dollars: number) => {
  return Math.ceil(dollars * 5);
};

export default convertToPoints;
